import * as Yup from "yup";
import ProductAvailabilityModel from "../../models/products/productavailability-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { DropDownList } from "@progress/kendo-react-dropdowns";

interface ProductAvailabilityEditProps {
    data: ProductAvailabilityModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const ProductAvailabilityEntry: React.FC<ProductAvailabilityEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.productavailabilityId > 0 ? "Edit Product Availability" : "Add Product Availability";

    let initialValue: ProductAvailabilityModel = {
        productavailabilityId: data?.productavailabilityId ? data.productavailabilityId : 0,
        productName: data?.productName || "",
        morningAvailability: data?.morningAvailability,
        eveningAvailability: data?.eveningAvailability,
        productId: data?.productId ? data.productId : 0
    };
    const validationSchema = Yup.object().shape({
        productName: Yup.string().required("Required"),

    });
    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PRODUCT}
                postRoute="ProductAvailability/SaveProductAvailability"
                showAddAnother={true}
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.productId > 0 ? true : false}
            >
                <div>
                    <div className="row">
                    <div className="col-4">
                            <InputField maxLength={100} 
                            label="Product Name" 
                            name="productName" />
                        </div>
                        <div className="col-4" style={{ marginTop: "2rem" }}>
                        <CheckboxField
                                label=" Morning Available?"
                                name="morningAvailability"
                                checkstyle={CheckBoxStyle.Normal}
                            />
                            </div>
                            <div className="col-4" style={{ marginTop: "2rem" }}>
                        <CheckboxField
                                label=" Evening Available?"
                                name="eveningAvailability"
                                checkstyle={CheckBoxStyle.Normal}
                            />
                            </div>                                          
                       
                    </div>
                </div>
            </FormikModelDialog>
        </>
    );
};

export default ProductAvailabilityEntry;


